import url from './url';
import { opinionPath } from './opinionPath';
import { createFeedStoryPreview } from './feedStoryPreview';
import { unsubscribeSearch } from '../unsubscribe/link';

// A known feed entry wins over search/history. Without one, resolve the newest
// public opinion of this event instead of leaving the event for another page.
export function storyFeedLink({ storyId, title, feedReturn, profileUsername }) {
  const origin = Number(feedReturn?.storyId) === Number(storyId) ? feedReturn : null;
  if (origin?.entry === 'unsubscribe') return { to: url('/unsubscribe') + unsubscribeSearch(origin.unsubscribeStoryId), state: origin.state };
  if (Number.isSafeInteger(origin?.reactionId) && origin.reactionId > 0) return {
    to: url(opinionPath(origin.reactionId, profileUsername || origin.state?.profileUsername)),
    state: { ...origin.state, feedStoryPreview: createFeedStoryPreview(origin.reactionId,
      { id: storyId, title }, origin.state?.feedRefresh ?? null) },
  };
  return { to: url(`/news/${storyId}/feed`), state: null };
}
